<template>
  <snap-global-header theme="store">
    <span>
      <snap-logo product="snap-logo-store" white="true" variant="1line"></snap-logo>
    </span>
    <snap-header-wrapper
      :redirect-on-signout="REDIRECTION_URL"
      show-app-switcher="true"
      show-login-buttons="false"
    />
  </snap-global-header>
</template>

<script lang="ts" setup>
const REDIRECTION_URL = window.location.href;
</script>

<style lang="scss"></style>
